/* eslint-disable react/forbid-prop-types */
import React, { Component } from 'react';
import {
  Typography, Grid,
} from '@material-ui/core';
import PropTypes from 'prop-types';

import ToolTip from './ToolTip';
import { resourceFormStyle } from '../../css/style';
import CraverRadio from './CraverRadio';

const styles = resourceFormStyle();

class FormRadioField extends Component {
  onChange = (event) => {
    const newValue = event;
    const { handleValueChange, field } = this.props;
    const { key } = field;
    handleValueChange({ key, newValue });
  }

  render() {
    const { field } = this.props;
    const { title, width, value } = field;
    return (
      <Grid
        item
        key={field.key}
        xs={field.gridWidth ? parseInt(field.gridWidth, 10) : 'auto'}
        style={styles.gridItem}
      >
        <div>
          <div style={styles.itemTitleContainer}>
            <Typography style={styles.itemTitle}>{`${title}:`}</Typography>
            <ToolTip field={field} width={width} />
          </div>
          <CraverRadio
            data={value}
            onChange={this.onChange}
          />
        </div>
      </Grid>
    );
  }
}

FormRadioField.propTypes = {
  field: PropTypes.objectOf(PropTypes.any).isRequired,
  handleValueChange: PropTypes.func.isRequired,
};

export default FormRadioField;
